import { callerCreator } from "../callerCreator";
import { articleSlice } from "./articleSlice";

export default callerCreator(articleSlice.actions);
